const footerNavGroups = [
  {
    title: '热门分类',
    links: [
      { label: '动作电影', href: '#index' },
      { label: '喜剧片', href: '#index' },
      { label: '科幻电影', href: '#index' },
      { label: '悬疑剧集', href: '#index' },
      { label: '动漫番剧', href: '#index' },
      { label: '纪录片', href: '#index' },
    ],
  },
  {
    title: '快速链接',
    links: [
      { label: '焦点专题', href: '#carousel' },
      { label: '热门话题', href: '#topics' },
      { label: '必看佳片', href: '#cards' },
      { label: '热度榜单', href: '#ranking' },
      { label: '专题合集', href: '#index' },
      { label: '常见问答', href: '#faq' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '用户反馈', href: '#comments' },
      { label: '最新快讯', href: '#updates' },
      { label: '影视特辑', href: '#media' },
      { label: '移动端下载', href: '#app' },
    ],
  },
];

export default function Footer() {
  const scrollToAnchor = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-800 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollToAnchor('#hero');
              }}
              className="flex items-center gap-2 mb-4"
            >
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-white whitespace-nowrap">
                丫丫影院
              </span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed mb-6">
              丫丫影院是国内领先的免费高清影视在线观看平台，汇聚海量影视资源，每日同步更新最新电影电视剧，提供不缓冲流畅观影体验。免费、高清、无需注册，让每个人都能轻松享受高品质影视内容。
            </p>
          </div>

          {footerNavGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-heading font-bold text-white mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToAnchor(link.href);
                      }}
                      className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30">
          <div className="mb-8">
            <h4 className="text-sm font-heading font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400">
              感谢所有合作伙伴的支持与信赖，期待与更多优秀团队携手同行
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2021-2026 丫丫影院 YayaCinema. All Rights Reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToAnchor('#faq');
                }}
                className="hover:text-white transition-colors"
              >
                服务条款
              </a>
              <span>·</span>
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToAnchor('#faq');
                }}
                className="hover:text-white transition-colors"
              >
                隐私政策
              </a>
              <span>·</span>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToAnchor('#contact');
                }}
                className="hover:text-white transition-colors"
              >
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}